import { chatResponseBlockRegistry } from './chatResponseBlockRegistryEntries.jsx'

export { chatResponseBlockRegistry }

/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {(props: Record<string, unknown>) => ReactNode} BlockComponent
 */

export function resolveChatResponseBlock(type) {
  return chatResponseBlockRegistry[type] ?? null
}
